import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { AumicoClipboardData } from '../../../../aumico-lib-core-fe/src/lib/interfaces/aumico-clipboard-data.interface';

export interface AddNoteAccordionResult {
    title: string;
    addNumbering: boolean;
    selectedComponent: ComponentType;
    pastedComponent?: AumicoClipboardData;
}
